var render = function render(){
  var _vm$body, _vm$body2, _vm$body3, _vm$body4, _vm$body5, _vm$body6;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row p6 radius6 animate-bottom e-warranty-card"
  }, [_c('div', {
    staticClass: "form-container-wrapper"
  }, [_vm.isFetching ? _c('div', {
    staticClass: "container-wrap"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container-wrap"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('div', {
    staticClass: "title-item"
  }, [_vm._v("E-Warranty Card")]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "split-item-link"
  }, [_vm._m(1), _c('div', [_c('vue-editor', {
    attrs: {
      "id": "editor1",
      "editor-toolbar": _vm.customToolbars
    },
    model: {
      value: _vm.body.termAndConditionEn,
      callback: function ($$v) {
        _vm.$set(_vm.body, "termAndConditionEn", $$v);
      },
      expression: "body.termAndConditionEn"
    }
  })], 1)]), _c('div', {
    staticClass: "split-item-link mt30"
  }, [_vm._m(2), _c('vue-editor', {
    attrs: {
      "id": "editor2",
      "editor-toolbar": _vm.customToolbars
    },
    model: {
      value: _vm.body.termAndConditionKh,
      callback: function ($$v) {
        _vm.$set(_vm.body, "termAndConditionKh", $$v);
      },
      expression: "body.termAndConditionKh"
    }
  })], 1), _c('div', {
    staticClass: "split-item-link mt30"
  }, [_vm._m(3), _c('div', {
    staticClass: "link-upload"
  }, [_c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "name": "attachment",
      "id": "attachment",
      "accept": ".pdf",
      "hidden": ""
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _c('span', {
    staticClass: "txt-attachment"
  }, [!((_vm$body = _vm.body) !== null && _vm$body !== void 0 && _vm$body.attachment) && !_vm.attachment && _vm.tempAttachment ? _c('span', {
    staticClass: "btn-remove",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "10px"
    },
    attrs: {
      "title": "Original Attachment"
    },
    on: {
      "click": function ($event) {
        _vm.body.attachment = _vm.tempAttachment;
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "15",
      "viewBox": "0 0 14 15",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.82751 0.75003C4.84001 0.80253 3.07751 1.71003 1.87751 3.12003L0.887506 2.13753C0.834635 2.0857 0.767605 2.05069 0.694864 2.03689C0.622123 2.0231 0.546927 2.03115 0.478752 2.06002C0.410578 2.08889 0.352476 2.1373 0.311769 2.19914C0.271062 2.26099 0.249572 2.33349 0.250006 2.40753V5.62503C0.250006 5.83503 0.415006 6.00003 0.625006 6.00003H3.84251C4.18001 6.00003 4.34501 5.59503 4.10501 5.36253L2.94251 4.19253C3.91001 3.01503 5.36501 2.25003 7.00001 2.25003C10.24 2.25003 12.805 5.20503 12.145 8.55753C11.74 10.635 10.0375 12.2925 7.96001 12.66C5.11001 13.17 2.57501 11.355 1.92251 8.79003C1.83251 8.47503 1.53251 8.25003 1.20251 8.25003C0.715006 8.25003 0.347506 8.70753 0.467506 9.17253C1.21001 12.09 3.85001 14.25 7.00001 14.25C10.795 14.25 13.855 11.1225 13.75 7.30503C13.645 3.64503 10.4875 0.66003 6.82751 0.75003ZM8.50001 7.50003C8.50001 6.67503 7.82501 6.00003 7.00001 6.00003C6.17501 6.00003 5.50001 6.67503 5.50001 7.50003C5.50001 8.32503 6.17501 9.00003 7.00001 9.00003C7.82501 9.00003 8.50001 8.32503 8.50001 7.50003Z",
      "fill": "currentColor"
    }
  })])]) : _vm._e(), (_vm$body2 = _vm.body) !== null && _vm$body2 !== void 0 && _vm$body2.attachment && !_vm.attachment ? _c('a', {
    attrs: {
      "href": _vm.fullPath((_vm$body3 = _vm.body) === null || _vm$body3 === void 0 ? void 0 : _vm$body3.attachment),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" " + _vm._s((_vm$body4 = _vm.body) === null || _vm$body4 === void 0 ? void 0 : _vm$body4.attachment) + " ")]) : _vm.attachment ? _c('span', [_vm._v(_vm._s((_vm$body5 = _vm.body) === null || _vm$body5 === void 0 ? void 0 : _vm$body5.attachment))]) : _c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "400",
      "color": "#979595"
    }
  }, [_vm._v(" No Attachment Found ")]), (_vm$body6 = _vm.body) !== null && _vm$body6 !== void 0 && _vm$body6.attachment ? _c('span', {
    staticClass: "btn-remove",
    on: {
      "click": _vm.deleteAttachment
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.6221 0.248289C12.6225 0.248426 12.6229 0.248641 12.6237 0.249441L13.7505 1.3762C13.7513 1.377 13.7515 1.37737 13.7516 1.37784C13.7518 1.37827 13.7518 1.37875 13.7516 1.37919C13.7515 1.37964 13.7513 1.38001 13.7505 1.38081L8.13125 7.00001L13.7505 12.6192C13.7513 12.62 13.7515 12.6204 13.7516 12.6208C13.7517 12.6213 13.7517 12.6218 13.7516 12.6222C13.7515 12.6226 13.7513 12.623 13.7505 12.6238L12.6237 13.7506C12.6229 13.7514 12.6225 13.7516 12.6221 13.7517C12.6216 13.7519 12.6211 13.7519 12.6207 13.7517C12.6203 13.7516 12.6199 13.7514 12.6191 13.7506L6.99989 8.13138L1.38069 13.7506C1.37991 13.7514 1.37951 13.7516 1.37907 13.7517C1.37862 13.7519 1.37814 13.7519 1.3777 13.7517C1.37727 13.7516 1.37688 13.7514 1.37608 13.7506L0.249319 12.6238C0.248518 12.623 0.248304 12.6226 0.248167 12.6222C0.248007 12.6217 0.248007 12.6213 0.248167 12.6208C0.248304 12.6204 0.248518 12.62 0.249319 12.6192L5.8685 7.00001L0.249319 1.38081C0.248518 1.38003 0.248304 1.37964 0.248167 1.37919C0.248031 1.37874 0.248031 1.37827 0.248167 1.37782C0.248304 1.37739 0.248518 1.377 0.249319 1.3762L1.37608 0.249441C1.37688 0.248641 1.37725 0.248426 1.37772 0.248289C1.37815 0.248129 1.37863 0.248129 1.37907 0.248289C1.37951 0.248426 1.37989 0.248641 1.38069 0.249441L6.99989 5.86862L12.6191 0.249441C12.6199 0.248641 12.6203 0.248426 12.6207 0.248289C12.6212 0.248153 12.6216 0.248153 12.6221 0.248289H12.6221Z",
      "fill": "currentColor",
      "fill-opacity": "0.5"
    }
  })])]) : _vm._e()]), _c('span', {
    staticClass: "txt-attachment-btn",
    on: {
      "click": _vm.triggerFileInput
    }
  }, [_vm._v(" Choose File ")])])])])]), _vm.checkoutPermission('CREATE_EWARRANTY_CARD') ? _c('div', {
    staticClass: "form-footer",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [false ? _c('button', {
    staticClass: "btn btn-light-secondary mr8",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" Cancel ")]) : _vm._e(), !_vm.isCreating ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Update ")]) : _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("Loading...")])]) : _vm._e()])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-item",
    staticStyle: {
      "min-height": "200px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "loader-circle"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v(" Warranty Term and Conditions (English) ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v(" Warranty Term and Conditions (Khmer) ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-title-title"
  }, [_c('span', {
    staticClass: "line-h31"
  }, [_vm._v("Attachment")])]);

}]

export { render, staticRenderFns }